// extracted by mini-css-extract-plugin
export default {"container":"Dimension_container__U0jAG","label":"Dimension_label__njtmb","graph":"Dimension_graph__PNzih","nodata":"Dimension_nodata__n-zaI"};